import VersionWaterMark from "./VersionWaterMark"

/**
 * @component App.
 * @returns {JSX.Element} - The App component.
 */
function App() {
  return (
    <div className="app">
      <VersionWaterMark />
    </div>
  );
}

export default App;
